import { useEffect } from 'react';

const SITE_ORIGIN = 'https://prestigebeauty.ee';
const DEFAULT_OG_IMAGE =
  'https://customer-assets.emergentagent.com/job_intelligent-shtern-10/artifacts/sqxzlr2k_att.8Zc65C_UdEBRo4EEO4ySl6o9RdfMl5YJ6hSL4eLLIP0.jpeg';

/**
 * Ensures a <meta name|property="..."> tag exists and sets its content.
 */
const setMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

/**
 * Ensures a <link rel="..."> tag exists and sets its href.
 */
const setLink = (rel, href) => {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

/**
 * Per-page SEO hook. Sets document.title plus meta description,
 * canonical URL, and Open Graph / Twitter card tags.
 *
 * Usage:
 *   useSEO({
 *     title: 'Teenused | Prestige Beauty & Wellness',
 *     description: '...',
 *     path: '/teenused',
 *   });
 */
const useSEO = ({ title, description, path, image }) => {
  useEffect(() => {
    if (typeof document === 'undefined') return;

    if (title) document.title = title;

    const url = `${SITE_ORIGIN}${path || '/'}`;
    const ogImage = image || DEFAULT_OG_IMAGE;

    setMeta('name', 'description', description);
    setLink('canonical', url);

    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:site_name', 'Prestige Beauty & Wellness');
    setMeta('property', 'og:locale', 'et_EE');
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', url);
    setMeta('property', 'og:image', ogImage);

    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);
    setMeta('name', 'twitter:image', ogImage);
  }, [title, description, path, image]);
};

export default useSEO;
